// extracted by mini-css-extract-plugin
module.exports = {"button":"ClassicButton_button__iVdWj"};